import { Component, ElementRef } from '@angular/core';

import * as d3 from 'd3';

import { BaseAxisChartComponent } from '../base/base-axis-chart.component';
import { Serie } from '../../../models';
import { ChartingService } from '../../../services';

@Component({
    selector: 'aa-column-chart',
    templateUrl: './column-chart.component.html',
    styleUrls: [
        './column-chart.component.scss'
    ],
    providers: [
        ChartingService
    ],
    standalone: false
})
export class ColumnChartComponent extends BaseAxisChartComponent
{
    public xScale: d3.ScaleOrdinal<any, number>;
    public yScale: d3.ScaleLinear<number, number>;

    constructor (
        elementRef: ElementRef,
        private chartingService: ChartingService
    )
    {
        super(elementRef);
    }

    protected onInit (): void
    {
        this.chartingService.config = this.cfg;
        this.xFormatTick = this.chartingService.xTimeFormatTick;
        this.yFormatTick = this.chartingService.yFormatTick;
        if (!this.config.title.draw)
        {
            this.config.dimensions.marginTop /= 2;
        }

        this.yFormatTick = d3.format(this.config.yFormatTick);

        this.series.forEach((elt: Serie, idx: number) =>
        {
            elt.id = idx;
            elt.dataPoints = this.data; // .map((d: any) => [Number(elt.xRawAccessor(d)), Number(elt.yAccessor(d))]);
        });
        this.dimensions = {
            ...this.dimensions,
            ...this.config.dimensions
        };
        this.calcBoundedDims();
    }

    public adjustScales (): void
    {
        // if (this.series.length === 0)
        // {
        //     return;
        // }

        this.mins = [];
        this.maxs = [];
        const visibleSeries = this.series.filter((s: Serie) => s.isVisible);
        if (visibleSeries.length > 0)
        {
            visibleSeries.forEach((serie: Serie) =>
            {
                this.mins.push(d3.min(this.data, serie.yAccessor));
                this.maxs.push(d3.max(this.data, serie.yAccessor));
            });

            // this.xScale = d3.scaleOrdinal()
            //     .domain(d3.extent(this.data, visibleSeries[0].xAccessor))
            //     .range([75, this.dimensions.boundedWidth]);
            this.yScale = d3.scaleLinear()
                .domain([d3.min(this.mins), d3.max(this.maxs)])
                .range([this.dimensions.boundedHeight, 0])
                .nice();

            visibleSeries.forEach((serie: Serie) =>
            {
                serie.y0AccessorScaled = (d) => this.yScale(this.yScale.domain()[0]);
                serie.xAccessorScaled = (d) => this.xScale(serie.xAccessor(d));
                serie.yAccessorScaled = (d) => this.yScale(serie.yAccessor(d));
            });
        }
    }

    onMousePosition ($event)
    {
    }
}
